module.exports = __webpack_public_path__ + "img/renewal_course_3.b61bdecb.png";